import React, {useState, useEffect} from 'react';
import { useFirestore } from 'reactfire';

const InvestigationShow = (props) => {
    let firestore = useFirestore();

    const [state, setState] = useState([]);
    useEffect(() => {
        getInvestigation();
    }, []);

    const getInvestigation = () => {

        let records = [];
        firestore.collection("Investigation_records")
            .where("appointment_id", "==", props.appID)
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    let record = doc.data();
                    // If there's no timestamp, set it to a default value
                    if (!record.timestamp) {
                        record.timestamp = new Date(0); // or any other default date
                    }
                    records.push({ data: record, id: doc.id });
                });
            })
            .finally(() => {
                // Sort the records by timestamp
                records.sort((a, b) => a.data.timestamp - b.data.timestamp);
    
                if(records.length > 0) {
                    setState(records);
                    console.log('In the Investigation era', records);
                }
            });

        
    }

    return (
        <React.Fragment>
            {state.length > 0 && <div className="tests_container"> <div className="showTestsTaken"> 
                <h2 style={{marginTop: '60px'}}>Investigation</h2>
                <ul>
                    {state && state.map((item) => {
                        return <li>
                            <h4>{item.data.test_info.testname}</h4>
                            <p>{item.data.test_info.note}</p>
                        </li>
                    })}
                
            </ul></div></div> }           
        </React.Fragment>
    );
}

export default InvestigationShow;
